import { render, staticRenderFns } from "./issueAbout.vue?vue&type=template&id=6f19abbc&scoped=true"
import script from "./issueAbout.vue?vue&type=script&lang=js"
export * from "./issueAbout.vue?vue&type=script&lang=js"
import style0 from "./issueAbout.vue?vue&type=style&index=0&id=6f19abbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19abbc",
  null
  
)

export default component.exports